import { render } from "./APTherapists.vue?vue&type=template&id=d4ea52b8&scoped=true"
import script from "./APTherapists.vue?vue&type=script&lang=js"
export * from "./APTherapists.vue?vue&type=script&lang=js"

import "./APTherapists.vue?vue&type=style&index=0&id=d4ea52b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4ea52b8"]])

export default __exports__